import { render, staticRenderFns } from "./LeftSidePane.vue?vue&type=template&id=4b42e4bd&scoped=true&"
import script from "./LeftSidePane.vue?vue&type=script&lang=ts&"
export * from "./LeftSidePane.vue?vue&type=script&lang=ts&"
import style0 from "./LeftSidePane.vue?vue&type=style&index=0&id=4b42e4bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b42e4bd",
  null
  
)

export default component.exports